export enum CardStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CLOSED = 'closed',
  FROZEN = 'frozen',
  PENDING = 'pending',
}

export enum CardType {
  PHYSICAL = 'physical',
  VIRTUAL = 'virtual',
}

export enum CardReplacementReason {
  LOST = 'lost',
  STOLEN = 'stolen',
  DAMAGED = 'damaged',
}

export enum CardIssuerType {
  FSA_DEBIT = 'fsaDebit',
  BUSINESS_DEBIT = 'businessDebit',
}

export enum CardHolderType {
  MEMBER = 'member',
  DEPENDENT = 'dependent',
}

export enum CountryCode {
  US = '1',
}

export enum CardTabName {
  FORMA_CARD = 'Forma Card',
  PRETAX_FORMA_CARD = 'Pre-tax Forma Card',
  WCS_HSA_CARD = 'WCS HSA Card',
  BENEFITS_CARD = 'Benefits Card',
}
